import React from "react";

import { FormattedMessage, useIntl } from "react-intl";
import { Row, Space, Select } from "@masterteam/mt-design-react";

import { useIsAr } from "../../../Hooks";

import "./style.scss";

const DashboardHeader = ({
  dashboardTitle,
  strategies,
  sectors,
  years,
  quarters,
  filters,
  setFilters,
  isLoading,
  isSectorsDashboard = false,
}) => {
  const intl = useIntl();
  const [isAr] = useIsAr();

  return (
    <Row className="dashboard-header" justify="between" align="center">
      <div className="dashboard-header__title">{`${intl.formatMessage({
        id: "common.dashboards",
      })} / ${intl.formatMessage({ id: dashboardTitle })}`}</div>

      <Space className="dashboard-header__filters" size="medium">
        {isSectorsDashboard ? (
          <Space align="center" className="dashboard-header__field-wrapper">
            <FormattedMessage id="common.sectors" />
            <Select
              options={sectors}
              placeholder={<FormattedMessage id="common.sectors" />}
              getOptionLabel={(el) => (isAr ? el.ArabicName : el.EnglishName)}
              getOptionValue={(el) => el?.ID}
              onChange={(item) => {
                setFilters({ ...filters, sectors: item });
              }}
              value={filters?.sectors}
              className="dashboard-header__select"
              disabled={isLoading}
              isMulti
            />
          </Space>
        ) : (
          <Space align="center" className="dashboard-header__field-wrapper">
            <FormattedMessage id="dashboards.strategic-strategy" />
            <Select
              options={strategies}
              placeholder={
                <FormattedMessage id="dashboards.strategic-strategy" />
              }
              getOptionLabel={(el) => (isAr ? el.ArabicName : el.EnglishName)}
              getOptionValue={(el) => el?.ID}
              onChange={(item) => {
                setFilters({ ...filters, strategy: item });
              }}
              value={filters?.strategy}
              className="dashboard-header__select"
              disabled={isLoading}
            />
          </Space>
        )}

        <Space align="center" className="dashboard-header__field-wrapper">
          <FormattedMessage id="dashboards.year" />
          <Select
            options={years}
            placeholder={<FormattedMessage id="dashboards.year" />}
            getOptionLabel={(el) => el?.Label}
            getOptionValue={(el) => el?.Value}
            onChange={(item) => {
              setFilters({ ...filters, year: item });
            }}
            value={filters?.year}
            className="dashboard-header__select"
            disabled={isLoading}
          />
        </Space>

        <Space align="center" className="dashboard-header__field-wrapper">
          <FormattedMessage id="dashboards.quarter" />
          <Select
            options={quarters}
            placeholder={<FormattedMessage id="dashboards.quarter" />}
            getOptionLabel={(el) => (isAr ? el.Arabic : el.English)}
            getOptionValue={(el) => el?.Value}
            onChange={(item) => {
              setFilters({ ...filters, quarter: item });
            }}
            value={filters?.quarter}
            className="dashboard-header__select"
            disabled={isLoading}
          />
        </Space>
      </Space>
    </Row>
  );
};

export default DashboardHeader;
